module.exports = __webpack_public_path__ + "static/media/appstore-4a.8e1db437.png";